import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=37122228&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=37122228&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37122228",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37122228')) {
      api.createRecord('37122228', component.options)
    } else {
      api.reload('37122228', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=37122228&scoped=true", function () {
      api.rerender('37122228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/Add.vue"
export default component.exports